import { render, staticRenderFns } from "./PromotionDetailsEdit.vue?vue&type=template&id=653951a4&scoped=true"
import script from "./PromotionDetailsEdit.vue?vue&type=script&lang=js"
export * from "./PromotionDetailsEdit.vue?vue&type=script&lang=js"
import style0 from "./PromotionDetailsEdit.vue?vue&type=style&index=0&id=653951a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653951a4",
  null
  
)

export default component.exports